import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: { title: 'Home' }
	},
	{
		path: '/assets/:id',
		name: 'assets',
		component: () =>
			import(/* webpackChunkName: "assets" */ '../views/Assets.vue'),
		meta: { title: 'Book an appointment' }
	},
	{
		path: '/assets/book/:id/:slot',
		name: 'bookasset',
		component: () =>
			import(
				/* webpackChunkName: "bookasset" */ '../views/BookAsset.vue'
			),
		meta: { title: 'Confirm your booking' }
	},
	{
		path: '/reserve',
		name: 'reserve',
		component: () =>
			import(/* webpackChunkName: "reserve" */ '../views/Reserve.vue'),
		meta: { title: 'Reserve a room' }
	},
	{
		path: '/reserve/room/:id',
		name: 'reserveRoom',
		component: () =>
			import(
				/* webpackChunkName: "reserve" */ '../views/ReserveRoom.vue'
			),
		meta: { title: 'Room details' }
	},
	{
		path: '/attend',
		name: 'attend',
		component: () =>
			import(/* webpackChunkName: "attend" */ '../views/Attend.vue'),
		meta: { title: 'Events' }
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

router.beforeEach((to, from, next) => {
	const embedded = from.query.embedded;
	const parentOrigin = from.query.parent_origin;

	if (!embedded && !parentOrigin) {
		next();
		return;
	}

	const nextQuery = {
		...to.query,
		...(embedded && !to.query.embedded ? { embedded } : {}),
		...(parentOrigin && !to.query.parent_origin
			? { parent_origin: parentOrigin }
			: {})
	};

	const embeddedChanged = nextQuery.embedded !== to.query.embedded;
	const parentChanged = nextQuery.parent_origin !== to.query.parent_origin;

	if (embeddedChanged || parentChanged) {
		next({
			name: to.name,
			params: to.params,
			query: nextQuery,
			hash: to.hash,
			replace: true
		});
		return;
	}

	next();
});

const APP_TITLE_SUFFIX = 'Communico';

router.afterEach(to => {
	const pageTitle = (to.meta && to.meta.title) || '';
	document.title = pageTitle
		? `${pageTitle} | ${APP_TITLE_SUFFIX}`
		: APP_TITLE_SUFFIX;
});

export default router;
